const styles = {
  sectionTitleWrapper: {
    fontSize: "26px",
    padding: "0 30px",
  },
  cardCarouselWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  iconCardCarouselContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  iconCardCarouselWrapper: {
    maxWidth: "767px",
  },
};

export default styles;
